<script lang="ts" setup>
  import { useFetchPressReleases } from '@/composables/useFetchPressReleases'
  import type { IButton } from '@/types/General/Button'

  const { fetchPressReleases } = useFetchPressReleases()
  const config = useRuntimeConfig()

  const { locale, t } = useI18n()

  const press = ref<any[]>([])

  const props = defineProps<{
    blok: any
  }>()

  watch(
    () => props.blok.buttonTitle,
    () => {
      buttonData.value = getButtonData()
    }
  )

  const getButtonData = () => {
    return {
      title: props.blok.buttonTitle,
      href: props.blok.href,
      target: props.blok.target,
      type: 'outlined'
    }
  }

  const mainPressPageUrl = () => {
    return formatSbPath(props.blok.mainPressPage?.story?.full_slug, locale.value)
  }

  const buttonData = ref<IButton>(getButtonData())

  const getPress = async () => {
    press.value = await fetchPressReleases(locale.value, 2, 1, new Date().getFullYear())
  }

  getPress()

  const openPressRelease = (slug: string) => {
    return `${config.public.companyUrl}/${locale.value}/${mainPressPageUrl()}?press=${slug}`
  }
</script>

<template v-if="press">
  <div class="flex flex-col items-stretch text-bt-blue-dark">
    <h2
      class="mb-6 text-h2 lg:mb-8"
      v-html="props.blok.title"
    />
    <div class="flex grow flex-col justify-between rounded-2xl bg-grey px-4 py-6 lg:!py-10 lg:!pl-8 lg:!pr-12">
      <div class="flex flex-col divide-y divide-divider">
        <div
          v-for="data in press"
          :key="data.id"
          class="block cursor-pointer first:pb-6 [&:not(:first-child)]:py-6"
        >
          <NuxtLink
            external
            :to="openPressRelease(data.slug)"
            class="flex flex-col gap-2"
          >
            <span class="text-body-1">{{ data.day }} {{ t(`reusable.monthShort.${data.month}`) }} {{ data.year }}</span>
            <h5
              class="text-h5"
              v-html="data.title"
            />
          </NuxtLink>
        </div>
      </div>
      <Button
        class="mt-8 lg:!mt-6"
        :blok="buttonData"
      />
    </div>
  </div>
</template>
